// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cf9b2cd8","457":"a8b502ea","551":"71aaa081","640":"6a998904","828":"640657fe","842":"5b68cd7c","851":"1d77be9c"}[chunkId] + ".chunk.js";
};